import Vue, { type Component } from 'vue';
import { createInertiaApp, router } from "@inertiajs/vue2";

import VueTelInput from "vue-tel-input";
Vue.use(VueTelInput);

import VueFormulate from "@braid/vue-formulate";
import FormulateVSelectPlugin from "@cone2875/vue-formulate-select";
Vue.use(VueFormulate, { plugins: [FormulateVSelectPlugin] });

import vfmPlugin from "vue-final-modal";
Vue.use(vfmPlugin);

import MainLayout from "@/layouts/MainLayout.vue";

createInertiaApp({
    progress: {
        color: '#4285F4',
    },
    title: (title) => title ? `${title} - MyListerHub` : 'MyListerHub',
    resolve: (name) => {
        const page = require(`./pages/${name}`).default;

        // if ((<any>window).layout) {
        //     return new Promise<Component>((resolve, reject) => {
        //         import((<any>window).layout)
        //             .then((layout) => {
        //                 page.layout = page.layout || layout;
        //                 resolve(page);
        //             })
        //             .catch(reject)
        //     });
        // }

        page.layout = page.layout || MainLayout;

        return page;
    },
    setup({ el, App, props, plugin }) {
        Vue.use(plugin);

        new Vue({
            // @ts-ignore
            render: (h) => h(App, props),
        }).$mount(el);
    },
});

router.on('invalid', (event) => {
    if (event.detail.response.status === 200) {
        event.preventDefault();
        window.location.href = event.detail.response.request.responseURL;
    }
});

router.on('success', (event) => {
    if (event.detail.page?.props?.module !== 'auth') {
        event.preventDefault();
        window.location.href = event.detail.page.url;
    }
});
